function Settings() {
  return (
    <div className="page-content">
      <div className="page-header">
        <h2>Settings</h2>
        <p>Configure your application preferences</p>
      </div>

      <div className="card-grid" style={{ marginTop: '24px' }}>
        <div className="card">
          <h3 style={{ marginBottom: '12px', color: '#1e293b' }}>Map Settings</h3>
          <p style={{ color: '#64748b', fontSize: '14px' }}>
            Configure default map view, zoom levels, and tile preferences.
          </p>
        </div>

        <div className="card">
          <h3 style={{ marginBottom: '12px', color: '#1e293b' }}>Display</h3>
          <p style={{ color: '#64748b', fontSize: '14px' }}>
            Customize the appearance and layout of the application.
          </p>
        </div>

        <div className="card">
          <h3 style={{ marginBottom: '12px', color: '#1e293b' }}>Data Sources</h3>
          <p style={{ color: '#64748b', fontSize: '14px' }}>
            Manage connected data sources and API integrations.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Settings
